export const DIALOG = {
  welcomeToConversations: 'Welcome to Conversations',
  description:
    'Get inspired and start making a big impact on your employee’s experience',
  activeSessions: 'Active sessions',
  archive: 'Archive',
  startNewConversation: 'New Conversation',
  newConversation: 'New Conversation',
  title: 'Title',
  question: 'Question',
  moderation: 'Moderation',
  analytics: 'Analytics',
  setup: 'Setup',
  participants: 'Participants',
  participant: 'Participant',
  responses: 'Responses',
  response: 'Response',
  likes: 'Likes',
  like: 'Like',
  dislikes: 'Dislikes',
  dislike: 'Dislike',
  comments: 'Comments',
  urlCopied: 'URL copied to clipboard',
  reply: 'Reply',
  replySingular: 'reply',
  replyPlural: 'replies',
  welcomeText1:
    'We would love to know more about your workplace experience. At this point all suggestions are welcome, let us know what you’d like to see. Your feedback is very valuable.',
  welcomeText2:
    'Thanks so much for sharing your thoughts with us. Your responses will remain anonymous. Select your avatar and name here:',
  continue: 'Continue',
  submit: 'Submit',
  noComments: 'No comments yet. Be the first one!',
  updateDialog: 'Update',
  noResponsesText:
    'No comments yet. Start by sharing the link with your coworkers to get the conversation started!',
  highlightedResponses: 'Highlighted responses',
  unarchive: 'Unarchive',
  archived: 'Archived',
  emptyHighlights: 'No highlights yet.',
  noDialogs: 'No conversations available',
  archivedDialogTitle:
    'Thanks for coming in to join this conversation! It has now been closed.',
  archivedDialogMessage:
    'Keep an eye out for upcoming discussions, we’d love to hear from you again soon.',
  summary: 'Summary',
  seeMore: 'See more...',
  seeLess: 'See less',
  keyMetrics: 'Key metrics',
  trendingTopics: 'Trending topics',
  overallSentiment: 'Overall sentiment',
  generatedOn: 'Generated on',
  negative: 'Negative',
  neutral: 'Neutral',
  positive: 'Positive',
  mostLiked: 'Most liked',
  mostDisliked: 'Most disliked',
  mostCommented: 'Most commented',
  highlighted: 'Highlighted',
  topic: 'Topic',
  all: 'All',
  actionRecommendation: 'Action recommendation',
  recommendedAction: 'Recommended action',
  selectInitiative: 'Select an initiative under which this action can be taken',
  selectInitiativePlaceholder: 'Select an initiative',
  keywords: 'Keywords',
  occurrences: 'Occurrences',
  topResponses: 'Top responses',
  moderator: 'Moderator',
  highlightResponse: 'Highlight response',
  emptyLikes: 'No favorites marked yet.',
  emptyDislikes: 'No concerns flagged yet.',
  emptyComments: 'No comments logged yet.',
  deleteDialog: 'Delete Conversation',
  duplicateTitleError: 'Conversation with this title already exists.',
  dialogNotFound: 'Conversation not found.',
  communityViolations: 'Community violations',
  pendingReview: 'Pending review',
  restrictedParticipants: 'Restricted participants',
  noRestrictedParticipants: 'No restricted participants.',
  noViolations: 'No violations to review',
  flaggedByAI: 'Flagged by AI for :',
  replyWarning: 'Warning: Reply hidden',
  responseWarning: 'Warning: Response hidden',
  replyWarningDescription:
    'Your reply may violate the community guidelines. The moderator has been notified. Read more about the',
  communityGuidelines: 'community guidelines.',
  communityGuidelinesHeading: 'Community guidelines',
  responseWarningDescription:
    'Your response has been hidden as it may violate the community guidelines. The moderator has been notified. Read more about the',
  guidelinesDescription:
    'Conversations is a space for honest, anonymous dialogue between employees and their organisation. These guidelines exist to keep that space safe, constructive, and useful for everyone.',
  text1: "Reacting to and building on other participants' ideas.",
  text2:
    "Moderators may restore the comment, permanently remove it, or restrict the participant's access.",
  addComment: 'Add a comment',
  addReply: 'Add Reply',
  coverImage: 'Cover Image',
  logo: 'Logo',
  failedToCreateConversation:
    'Failed to create conversation. Please try again.',
  failedToUpdateConversation:
    'Failed to update conversation. Please try again.',
  failedToUpdateConversationStatus:
    'Failed to update conversation status. Please try again.',
  failedToDeleteConversation:
    'Failed to delete conversation. Please try again.',
  failedToSaveActionTopic: 'Failed to save action topic. Please try again.',
  failedToUpdateHighlight: 'Failed to update highlight. Please try again.',
  failedToUpdateResponse: 'Failed to update response. Please try again.',
  failedToDeleteReply: 'Failed to delete reply. Please try again.',
  failedToAllowUser: 'Failed to allow user. Please try again.',
  failedToRestrictUser: 'Failed to restrict user. Please try again.',
  failedToUpdateItem: 'Failed to update item. Please try again.',
  failedToDeleteItem: 'Failed to delete item. Please try again.',
  failedToDeleteResponse: 'Failed to delete response. Please try again.',
  responseUpdated: 'Response updated successfully.',
  responseDeleted: 'Response deleted successfully.',
  replyDeleted: 'Reply deleted successfully.',
  failedToSaveReaction: 'Failed to save reaction. Please try again.',
  failedToAddReply: 'Failed to add reply. Please try again.',
  somethingWentWrongTryAgain: 'Something went wrong. Please try again.',
} as const
